import LogoWithText from "../../images/logo-with-text.svg";

export const LargeLogoWithText = () => (
  <img className="h-14" src={LogoWithText.src} alt="Gwak logo" width="auto" />
);
